<template>
  <div>
    <v-card>
      <div v-padding="3">
        <div v-margin.bottom="1" v-margin.top="1">
          <v-text>
            Наша компания успешно работает на российском IT-рынке с 2009 года.
            Уже 12 лет под брендом ЭБК мы производим качественные онлайн-сервисы
            в секторах b2b и b2c, основанные на кредитной информации и смежных
            данных (ЦККИ, БКИ, ФНС, межбанковский обмен информацией).
          </v-text>
        </div>

        <div v-margin.bottom="2">
          <v-text type="title">Контакты:</v-text>
        </div>

        <div v-margin.bottom="1">
          <v-text>
            620014, г. Екатеринбург, ул. Сакко и Ванцетти, 64, 4 этаж, офис 404
          </v-text>
        </div>
        <div v-margin.bottom="1">
          <v-text> тел. +7 (495) 374-87-74 </v-text>
        </div>
        <div v-margin.bottom="2">
          <v-text> e-mail: support@exbico.ru </v-text>
        </div>

        <div v-text-align.left v-margin.top="2">
          <v-button primary @click="open"> Связаться с поддержкой </v-button>
        </div>
      </div>
    </v-card>
    <v-modal :active="isShowModal" @close="isShowModal = false">
      <div v-padding="2" v-margin.top="1">
        <v-text type="headline">Обращение в поддержку</v-text>
        <v-icon-button @click="close" style="margin-left: 249px"> close </v-icon-button>
      </div>
      <div v-padding="2">
        <div v-margin.bottom="1">
          <textarea
            label="message"
            style="width: 574px; height: 316px; outline: none; resize: none; border: 1px solid rgb(214,214,214); border-radius: 2px; padding:5px;"
            placeholder="Оставьте ваше сообщение..."
            @input="updateMessage($event.target.value)"
          ></textarea>
        </div>

        <div v-text-align.center v-margin.top="1">
          <v-button primary @click="requestSupport"> Оставить заявку </v-button>
        </div>
      </div>
    </v-modal>
    <v-modal :active="isShowConfirm" @close="isShowConfirm = false">
      <div v-padding="2">
        <div v-margin.bottom="1">
          <v-text type="title" v-margin.bottom="2"> Спасибо </v-text>
        </div>
        <div v-margin.bottom="1">
          <v-text type="title" v-margin.bottom="2">
            Ваша заявка принята
          </v-text>
        </div>

        <div v-margin.bottom="1">
          <v-text v-margin.bottom="2">
            Мы свяжемся с вами в ближайшее время.
          </v-text>
        </div>

        <div v-text-align.right v-margin.top="1">
          <v-button flat @click="close"> Закрыть </v-button>
        </div>
      </div>
    </v-modal>
  </div>
</template>
<script>
import { requestSupport } from "../../../services/api/profile";
export default {
  name: "contacts",
  data() {
    return {
      isShowModal: false,
      isShowConfirm: false,
      message: "",
    };
  },
  methods: {
    open() {
      this.isShowModal = true;
    },
    close() {
      this.isShowModal = false;
      this.isShowConfirm = false;
    },
    updateMessage(value) {
      this.message = value;
    },
    requestSupport() {
      requestSupport(this.message).then(() => {
        this.isShowModal = false;
        this.isShowConfirm = true;
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// Contacts.vue?cbdec49a